import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PageLoader } from '@app/components/PageLoader';
import { Table } from '@app/components/Table';
import { LoanPurposes } from '@app/configs/loanApplication';
import { useIsMobile } from '@app/utils/isMobile';
import { mapPastLoansToColumns } from '../../utils/mapPastLoansToColumns';
import LoanStatus from '../loans/LoanStatus';
import PastLoansTableMobile from './mobile/PastLoansTableMobile';
const PastLoansTable = ({ pastLoans, loading }) => {
    const { t } = useTranslation();
    const [isMobile] = useIsMobile();
    const getStatusColumn = useCallback(({ row: { original } }) => <LoanStatus status={original.status}/>, []);
    const getPurposeColumn = useCallback(({ row: { original } }) => (<span>
                {original.purpose === LoanPurposes.Empty
            ? original.id
            : t(`financing.loan_purpose.${original.purpose}`)}
            </span>), [t]);
    const columns = [
        {
            header: t('financing.investing_page_table.id'),
            accessorKey: 'loanId',
            size: 56,
        },
        {
            header: t('financing.investing_page_table.creation_date'),
            accessorKey: 'creationDate',
            size: 120,
        },
        {
            header: t('financing.investing_page_table.status'),
            accessorKey: 'status',
            cell: getStatusColumn,
        },
        {
            header: t('financing.investing_page_table.purpose'),
            accessorKey: 'purpose',
            cell: getPurposeColumn,
        },
        {
            header: t('financing.investing_page_table.period'),
            accessorKey: 'period',
        },
        {
            header: t('financing.investing_page_table.requested'),
            accessorKey: 'requested',
        },
        {
            header: t('financing.borrowing_page.collected'),
            accessorKey: 'collected',
        },
    ];
    const data = mapPastLoansToColumns(pastLoans, t);
    if (loading) {
        return <PageLoader />;
    }
    return isMobile ? <PastLoansTableMobile pastLoans={pastLoans}/> : <Table columns={columns} data={data}/>;
};
export default PastLoansTable;
